import { render, staticRenderFns } from "./OrderPayFail.vue?vue&type=template&id=10fe7fa7&"
import script from "./OrderPayFail.vue?vue&type=script&lang=ts&"
export * from "./OrderPayFail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports